module.exports = __webpack_public_path__ + "img/receipt-header-bw.a4a0d468.png";